// extracted by mini-css-extract-plugin
export var notificationHost = "_f3-0";